import { useEffect, useState } from 'react';
import axios from 'axios';
import { formatNumber } from './numberFormat';

// The tenant's Shipment Weight Unit (kg or lb) and Shipment Dimension Unit
// (cm or in), from Platform Settings → Weight & Dimension Units — the units
// every package's weight and Length/Width/Height (and each Packaging's
// dimensions) are entered in,
// kept apart from the Product UoM units. '' until set. Fetched once per page
// load and shared by every screen that shows a shipment weight or size.

let cached = null;

function loadUnits() {
  if (!cached) {
    cached = axios.get('/api/platform-settings')
      .then((res) => ({
        weight: res.data.data?.shipment_weight_unit || '',
        dimension: res.data.data?.shipment_dimension_unit || '',
      }))
      .catch(() => {
        cached = null;
        return { weight: '', dimension: '' };
      });
  }
  return cached;
}

// Platform Settings calls this once a unit is locked in, so screens
// opened afterwards in the same session pick it up.
export function clearShipmentWeightUnitCache() {
  cached = null;
}

function useShipmentUnit(key) {
  const [unit, setUnit] = useState('');
  useEffect(() => {
    let cancelled = false;
    loadUnits().then((units) => { if (!cancelled) setUnit(units[key]); });
    return () => { cancelled = true; };
  }, [key]);
  return unit;
}

export function useShipmentWeightUnit() {
  return useShipmentUnit('weight');
}

export function useShipmentDimensionUnit() {
  return useShipmentUnit('dimension');
}

// "Weight (kg)", or plain "Weight" until the unit is set.
export function shipmentWeightLabel(unit) {
  return unit ? `Weight (${unit})` : 'Weight';
}

// "Dimensions (cm)", or plain "Dimensions" until the unit is set.
export function shipmentDimensionLabel(unit) {
  return unit ? `Dimensions (${unit})` : 'Dimensions';
}

// "40.0 × 30.0 × 20.0" from a package's (or a Packaging's) length/width/
// height, blanks shown as "—"; null when none of the three is entered.
export function formatDimensions(row) {
  const parts = [row.length, row.width, row.height];
  if (parts.every((v) => v === null || v === undefined || v === '')) return null;
  return parts.map((v) => (v === null || v === undefined || v === '' ? '—' : formatNumber(v, { decimals: 1 }))).join(' × ');
}
